/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".numbered-list{display:flex;align-content:flex-start}.numbered-list .mat-mini-fab{flex:1 1 content;height:24px;width:24px;line-height:24px;margin-top:14px;cursor:pointer}.numbered-list .mat-mini-fab span{padding:0}.numbered-list .instruction-step{flex:10 0 0;margin-left:12px}.numbered-list .instruction-step .mat-form-field{flex:10 0 0}"];
export { styles as styles };
